// Desktop prev/next arrows over the main product image (see
// snippets/product-media-gallery.liquid). Steps through the media items in the
// gallery viewer and hands off to <media-gallery> so the thumbnails, live
// region and any deferred media stay in sync. Delegated from the document so it
// survives product-info re-rendering the section on a variant change.
if (!window.productMediaArrowsInit) {
  window.productMediaArrowsInit = true;
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('.product__media-arrow');
    if (!arrow) return;

    const gallery = arrow.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    // Slide <li>s only. Media elements inside each slide carry a bare
    // [data-media-id] too, so an unscoped query returns twice as many nodes
    // and hands setActiveMedia an id that hides every slide.
    const items = Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
    if (items.length < 2) return;

    const current = Math.max(
      items.findIndex((item) => item.classList.contains('is-active')),
      0
    );
    const step = arrow.classList.contains('product__media-arrow--next') ? 1 : -1;
    const next = items[(current + step + items.length) % items.length];

    gallery.setActiveMedia(next.dataset.mediaId, false);
  });
}
